import { useState, useCallback } from 'react';
import APIRequest from '../../../services/APIRequest';

export default function useApiKeyDetail() {
  const [apiKey, setApiKey] = useState(null);
  const [subscription, setSubscription] = useState(null);
  const [usageMetrics, setUsageMetrics] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchApiKeyDetail = useCallback(async (apiKeyId) => {
    try {
      setLoading(true);
      setError(null);
      const response = await APIRequest.get(`admin/apikey/${apiKeyId}`);
      if (response?.ok) {
        const data = response.data?.data;
        setApiKey(data?.apiKey || null);
        setSubscription(data?.subscription || null);
        setUsageMetrics(data?.usageMetrics || null);
      } else {
        setError(response?.data?.message || response?.problem || 'Failed to fetch API key details');
      }
    } catch (err) {
      setError(err?.message || 'An unexpected error occurred');
    } finally {
      setLoading(false);
    }
  }, []);

  return { apiKey, subscription, usageMetrics, loading, error, fetchApiKeyDetail };
}


